"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExceptionOpcodeTemplates = getExceptionOpcodeTemplates;
function getExceptionOpcodeTemplates() {
    return `
                        // Exception Handling Operations
                        case opMap[58]: { // TRY_START
                            // Register exception handler
                            // Exception data stored in exHandlers[pc] = [catchIdx, finallyIdx, endIdx]
                            // Values are XOR-encoded if vmJumpsEncoding is enabled
                            let exData = exHandlers[pc];
                            exceptionHandlers.push({
                                catchIndex: exData[0] >= 0 ? decodeJump(exData[0]) : undefined,
                                finallyIndex: exData[1] >= 0 ? decodeJump(exData[1]) : undefined,
                                endIndex: exData[2] >= 0 ? decodeJump(exData[2]) : undefined,
                                stackSize: stack.length
                            });
                            pc++;
                            break;
                        }

                        case opMap[59]: { // TRY_END
                            // Normal completion of try block - pop exception handler
                            exceptionHandlers.pop();
                            pc++;
                            break;
                        }

                        case opMap[60]: { // CATCH_START
                            // Exception is already on stack (from throw)
                            // If arg is -1, just pop and discard (catch without parameter)
                            // Otherwise, arg is the constant pool index of the parameter name
                            // Store exception in CURRENT environment (not parent) to support shadowing
                            let exception = stack.pop();
                            if (arg >= 0) {
                                let catchParamName = constants[arg];
                                // Always create variable in current environment, not parent
                                // This allows catch parameters to shadow outer const variables
                                env.vars[catchParamName] = exception;
                            }
                            pc++;
                            break;
                        }

                        case opMap[61]: { // FINALLY_START
                            // Finally block begins
                            // Pop exception handler if it still exists (normal control flow from catch)
                            // If we got here via exception, the handler was already popped
                            if (exceptionHandlers.length > 0) {
                                let topHandler = exceptionHandlers[exceptionHandlers.length - 1];
                                // Only pop if this is the handler for this try-catch-finally
                                // (check if finallyIndex matches current pc)
                                if (topHandler.finallyIndex === pc) {
                                    // Save any pending exception from this handler
                                    if (topHandler.pendingException !== undefined) {
                                        pendingException = topHandler.pendingException;
                                    }
                                    exceptionHandlers.pop();
                                }
                            }
                            pc++;
                            break;
                        }

                        case opMap[62]: { // FINALLY_END
                            // Finally block ended
                            // If there's a pending return, return that value (unless finally also returned)
                            if (pendingReturn.hasReturn) {
                                let returnValue = pendingReturn.value;
                                pendingReturn.hasReturn = false;
                                pendingReturn.value = undefined;
                                return returnValue;
                            }
                            // If there's a pending break, jump to break target
                            if (pendingBreak.hasBreak) {
                                let breakTarget = pendingBreak.target;
                                pendingBreak.hasBreak = false;
                                pendingBreak.target = 0;
                                pc = breakTarget;
                                break;
                            }
                            // If there's a pending continue, jump to continue target
                            if (pendingContinue.hasContinue) {
                                let continueTarget = pendingContinue.target;
                                pendingContinue.hasContinue = false;
                                pendingContinue.target = 0;
                                pc = continueTarget;
                                break;
                            }
                            // If there's a pending exception, re-throw it
                            if (pendingException !== null) {
                                let exToThrow = pendingException;
                                pendingException = null;
                                throw exToThrow;
                            }
                            pc++;
                            break;
                        }
    `;
}
